<template>
  <SectionLayout :section-title="sectionTitle" is-paging :current-page="currentPage" :total-pages="totalPages" @paging="moveToPage"  section-key="topIntegrations" footer-class="mt-0">
    <template #default>
      <div class="border-radius overflow-x-hidden pt-1 pl-1 pr-1 integration__container">
        <div class="row slide__list pb-2" :style="listDynamicStyle">
          <div class="col-6 px-1" v-for="(item, index) in allIntegrations" :key="`${item.id}_${index}`">
            <article class="p-2 integration-item" :class="item.status" :type="item.metas.type" @click.stop="previewIntegration(item)">
              <div class="d-flex flex-grow-1">
                <div class="integration-item__left mr-2">
                  <div class="integration-item__thumbnail" :class="thumbnailTransparentClass(item)">
                    <img :src="item.metas.iconImage" v-if="item.metas.iconType == 'image'" />
                  </div>
                  <div class="integration-item__popularity text-accent-amber mt-1" v-if="item.status != 'soon'">
                    <i class="icon icon-fire typo-icon-10 mr-half"></i>
                    <span class="typo-p10 typo-regular">{{ item.popularity }}</span>
                  </div>
                </div>
                <div class="integration-item__right">
                  <h3 class="integration-item__title mb-half line-1">{{ item.label }}</h3>
                  <div class="integration-item__short-desc typo-p12 typo-regular line-2" v-html="item.short_desc">{{ item.short_desc }}</div>
                  <div class="d-flex align-items-center mt-4px">
                    <svg class="mr-4px" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8.0001 11.5133L12.1201 14L11.0268 9.31334L14.6668 6.16001L9.87343 5.74668L8.0001 1.33334L6.12677 5.74668L1.33344 6.16001L4.96677 9.31334L3.8801 14L8.0001 11.5133Z" fill="#FFB21C" />
                    </svg>

                    <span class="integration-item__rating">
                      {{ item.metas.ratingPoints || 0 }}
                    </span>
                  </div>
                  <div class="mt-2 integration-item__price">
                    {{ priceText }}
                  </div>
                </div>
              </div>
            </article>
          </div>
        </div>
      </div>

      <Modal v-if="showPreview" :active="showPreview" :hideExit="false" cClass="app-details-modal" padding="p-0" closeClass="app-details-close p-1" @cancel="closePreview" @container="closePreview">
        <div class="app-details py-4 px-3 text-black bg-light3">
          <div class="row">
            <div class="col-8">
              <div class="row">
                <div class="col-12 d-flex">
                  <div class="app-logo">
                    <img :src="previewItem.metas.appIcon" v-if="previewItem && previewItem.metas.appIcon" />
                    <img class="app-logo-mock" v-else :src="publicPath + require('@/core/assets/Integration/calendar.svg')" />
                  </div>
                  <div class="app-info ml-2">
                    <h4 class="typo-heading20 typo-medium mb-half">
                      {{ previewItem.label }}
                    </h4>
                    <p class="typo-button14 typo-medium d-flex align-items-center mb-1">
                      <svg width="20" height="20" viewBox="0 0 20 22" fill="none" class="text-warning">
                        <g>
                          <path d="M19.6291 8.05486C19.5401 7.80434 19.3802 7.58823 19.1709 7.43537C18.9615 7.28252 18.7126 7.2002 18.4574 7.19941H13.3849C13.2986 7.19947 13.2144 7.17146 13.1439 7.11923C13.0735 7.067 13.0202 6.99314 12.9916 6.90786L11.1708 1.50192C11.0816 1.25206 10.9217 1.03669 10.7124 0.884647C10.5032 0.732599 10.2546 0.651123 9.99992 0.651123C9.74526 0.651123 9.49668 0.732599 9.28743 0.884647C9.07819 1.03669 8.91828 1.25206 8.82909 1.50192L8.82492 1.51589L7.00826 6.90786C6.97965 6.993 6.92654 7.06676 6.85624 7.11898C6.78595 7.17119 6.70193 7.19929 6.61576 7.19941H1.54159C1.28477 7.19921 1.03413 7.28187 0.823742 7.43616C0.61336 7.59045 0.453451 7.80887 0.365766 8.06172C0.27808 8.31457 0.266873 8.58957 0.33367 8.84933C0.400466 9.10909 0.542024 9.34099 0.739089 9.51349L5.05909 13.267C5.12371 13.3232 5.17062 13.3985 5.19367 13.4831C5.21672 13.5677 5.21483 13.6576 5.18826 13.741L3.37326 19.442C3.28938 19.7056 3.28772 19.9903 3.36853 20.2549C3.44933 20.5196 3.60841 20.7504 3.82275 20.9141C4.03709 21.0778 4.29559 21.1658 4.56084 21.1654C4.82609 21.165 5.08435 21.0763 5.29826 20.912L9.75326 17.4902C9.82469 17.4353 9.91095 17.4058 9.99951 17.4058C10.0881 17.4058 10.1743 17.4353 10.2458 17.4902L14.6991 20.9111C14.9129 21.0759 15.1713 21.1652 15.4368 21.1659C15.7023 21.1667 15.9611 21.0788 16.1757 20.9152C16.3904 20.7515 16.5497 20.5205 16.6306 20.2556C16.7115 19.9908 16.7098 19.7058 16.6258 19.442L14.8108 13.7375C14.7842 13.6541 14.7823 13.5642 14.8053 13.4796C14.8284 13.395 14.8753 13.3197 14.9399 13.2635L19.2683 9.50477C19.4628 9.3308 19.6017 9.0985 19.6662 8.83922C19.7308 8.57995 19.7178 8.30618 19.6291 8.05486Z" fill="currentColor" />
                        </g>
                      </svg>

                      <span class="d-inline-flex align-items-center ml-1">
                        {{ previewItem.metas.ratingPoints || 0 }}
                      </span>
                    </p>
                    <p class="typo-paragraph12 typo-lh-150 text-light-disabled mb-1">
                      <span>{{ $t("integration.by", { name: previewItem.author || "GemPages" }) }}</span>
                      <span> | </span>
                      <a :href="previewItem.website || 'https://gempages.net'" target="_blank" class="text-primary">
                        {{ website }}
                      </a>
                    </p>
                    <div class="row pt-half">
                      <div class="col-12">
                        <a class="support-link d-flex align-items-center typo-paragraph12 typo-lh-150 text-light-disabled" target="_blank" :href="'mailto:' + (previewItem.metas.emailSupport || 'contact@gempages.help')">
                          <svg width="14" height="15" viewBox="0 0 14 15" class="mr-1">
                            <path d="M11.6668 2.25488H2.3335C1.36706 2.25488 0.583496 3.03845 0.583496 4.00488V11.0049C0.583496 11.9713 1.36706 12.7549 2.3335 12.7549H11.6668C12.6333 12.7549 13.4168 11.9713 13.4168 11.0049V4.00488C13.4168 3.03845 12.6333 2.25488 11.6668 2.25488ZM11.6668 3.42155C11.7338 3.42155 11.7971 3.43511 11.8568 3.45582L7.00016 7.34111L2.14348 3.45582C2.20341 3.43511 2.26656 3.42155 2.3335 3.42155H11.6668ZM11.6668 11.5882H2.3335C2.0112 11.5882 1.75016 11.3272 1.75016 11.0049V4.63532L6.63573 8.54365C6.74218 8.62897 6.87125 8.67155 7.00016 8.67155C7.12908 8.67155 7.25814 8.62897 7.3646 8.54365L12.2502 4.63532V11.0049C12.2502 11.3272 11.9891 11.5882 11.6668 11.5882Z" fill="currentColor" />
                          </svg>
                          {{ previewItem.metas.emailSupport || "contact@gempages.help" }}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-4 align-items-end justify-content-end d-flex">
              <a class="btn btn-try btn-primary" target="_blank" :href="previewItem && previewItem.metas.installLink">{{ $t("integration.tryIt") }}</a>
            </div>
          </div>
          <!-- Description and tags -->
          <div class="row mt-4">
            <div class="col-7">
              <p class="typo-paragraph14 typo-regular-150 text-light-low" v-html="previewItem.short_desc"></p>
            </div>
            <div class="col-5">
              <div class="bundles mt-n1 ml-n1">
                <Tag class="mt-1 ml-1" v-for="(w, _i) in previewItem.bundle" :key="'selected' + _i" :item="w" />
              </div>
            </div>
          </div>

          <hr class="bg-dark-high my-3" />
          <p class="typo-heading16 typo-medium mb-2">{{ $t("integration.howToInstall") }}</p>
          <p class="typo-paragraph14 typo-regular typo-lh-150 text-light-low mb-2" v-html="previewItem.metas.howToInstall"></p>
          <div class="app-video">
            <template v-if="previewItem && previewItem.metas.helpVideo">
              <video controls ref="video" class="" width="100%" height="auto" loop="true" preload="none" muted="false" playsinline autoplay="true" :src="previewItem.metas.helpVideo">
                <source :src="previewItem.metas.helpVideo" type="video/mp4" />
              </video>
            </template>
            <img v-else :src="publicPath + require('@/core/assets/Integration/video.jpg')" />
          </div>
        </div>
      </Modal>
      <!-- <IntegrationDetailView :item="previewItem" @close="closePreview" /> -->
    </template>
  </SectionLayout>
</template>

<script>
import SectionLayout from "./SectionLayout.vue";
import { mapState } from "vuex";

export default {
  name: "TopIntegrations",
  components: {
    SectionLayout
  },
  data: () => ({
    currentPage: 1,
    numberPerPage: 2,
    previewItem: null
  }),
  computed: {
    ...mapState("dashboard", {
      allIntegrations: "topIntegrations"
    }),
    sectionTitle() {
      return this.$t("integration.title");
    },
    linkTemplateText() {
      return this.$t("general.exploreMore");
    },
    totalPages() {
      return Math.ceil(this.allIntegrations.length / this.numberPerPage);
    },
    showPreview() {
      return this.previewItem != null;
    },
    website() {
      if (this.previewItem && !this.previewItem.website) {
        return "https://gempages.net";
      }
      let split = this.previewItem.website.split("?");
      if (!split || !split.length) return "https://gempages.net";

      let website = split[0];
      return website;
    },
    listDynamicStyle() {
      return {
        transform: `translateX(${-100 * (this.currentPage - 1)}%)`
      }
    },
    priceText() {
      return this.$t("dashboard.priceText");
    }
  },
  methods: {
    moveToPage(index) {
      this.currentPage = index;
    },
    closePreview() {
      this.previewItem = null;
    },
    previewIntegration(item) {
      this.previewItem = item;
    },
    thumbnailTransparentClass(item) {
      return {
        "integration-item__thumbnail--background-transparent": item.metas.iconType == "image"
      };
    }
  }
};
</script>

<style lang="scss">
.integration {
  &__container {
    margin: -8px -8px 0px -8px;
  }
  &-item {
    position: relative;
    background: $light1;
    padding: 0;
    display: flex;
    flex-direction: column;
    border-radius: $radius;
    height: 155px;
    border: 1px solid #D6D6D6;

    &.is-loading {
      overflow: hidden;
      pointer-events: none;
    }

    $size: 48px;
    &__left {
      min-width: $size;
    }

    &__right {
      flex: 1;
    }

    &__thumbnail {
      width: $size;
      color: #fff;
      height: $size;
      border-radius: $radius;
      overflow: hidden;
      @include flex-center;
      font-size: 1.7em;

      &--background-transparent {
        background-color: transparent !important;
      }
      img {
        width: 100%;
      }
    }

    &__short-desc {
      color: #676767;
      font-size: 12px;
      line-height: 150%;
      font-weight: 400;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
      max-height: 3rem;
      width: 100%;
      -webkit-line-clamp: 2;
    }

    &__title {
      color: #212121;
      font-size: 16px;
      line-height: 150%;
      font-weight: 500;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
      max-height: 1.5em;
      width: 100%;
      -webkit-line-clamp: 1;
    }

    &__rating {
      color: #676767;
      font-weight: 400;
      font-size: 14px;
      line-height: 150%;
    }
    &__price {
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
      color: #666666;
    }

    &[type="row"] {
      .integration-item__thumbnail {
        background: $mono3;
      }
    }

    &[type="element"] {
      .integration-item__thumbnail {
        background: $accent-green;
      }
    }

    &[type="module"] {
      .integration-item__thumbnail {
        background: #e82b71;
      }
    }

    &__uninstaller {
      &:not(.disabled):not(:disabled):hover {
        cursor: pointer;
        text-decoration: underline;
      }
    }

    &:not(.soon):not(.is-loading):hover {
      border: 1px solid #5B5B5B;
      cursor: pointer;
    }

    &__soon {
      cursor: pointer;
      color: $textLightModeDisabled;
      display: inline;
      &:hover {
        color: $textLightModeLow;

        path {
          fill: $textLightModeLow;
        }

        .tooltip__title {
          display: flex;
        }
      }
    }
  }
}
</style>
